<template>
  <div class="contact-us">
<h3>{{title}}</h3>
<h5>{{subtitle}}</h5>
<div class="contact">
  <h4>Arrange a call.</h4>

  <q-input v-model="name" float-label="Full name" style="{display: block-inline}" />
  <q-input v-model="phone" float-label="Phone number" type="tel" />
  <div style="height: 5vh"></div>
  <div style="float: right">
    <q-btn pull-right icon="create" outline>Request a call</q-btn>
  </div>
  <div style="height: 10vh"></div>
</div>
  </div>
</template>

<script>
import {
  QInput,
  QBtn
} from 'quasar-framework'

export default {
  components: {
    QInput,
    QBtn
  },
  props: ['title', 'subtitle'],
  data: function () {
    return {
      phone: '',
      name: ''
    }
  }
}
</script>

<style scoped lang="stylus">
.contact-us
  margin: 2% auto
  padding-left: 5%
  padding-right: 5%
  max-width: 730px
</style>



// WEBPACK FOOTER //
// ContactUs.vue?37f28346